import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UserAccountContainer } from '@components/organisms/UserAccountContainer';
import { AlertsTable } from '@components/molecules/AlertsTable';
import { useGetAlerts } from '@services/useGetAlerts';

export const AdminAlertsList: FC = () => {
    const { t } = useTranslation();
    const { request, alerts, loading } = useGetAlerts();

    useEffect(() => {
        request();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <UserAccountContainer title={t('user-account-sidebar.alerts')}>
            <AlertsTable alerts={alerts} loading={loading} onRefresh={request} />
        </UserAccountContainer>
    );
};
